const round2 = (value) => Math.round((Number(value) || 0) * 100) / 100;

export const CAPITAL_GAIN_SUMMARY_STATUS = {
    loading: 'loading',
    saved: 'saved',
    computed: 'computed',
    error: 'error',
};

export function getSnapshotAssetId(snapshot) {
    return snapshot?.soldAssetId ?? snapshot?.SoldAssetId ?? null;
}

/** API save item for one sold asset from a buildCapitalGainResult result. */
export function buildCapitalGainSnapshotItem(soldAssetId, result) {
    const details = {
        saleDate: result.saleDate,
        enhancementsBalance: result.enhancementsBalance,
        enhancementsAccumulatedDepreciation: result.enhancementsAccumulatedDepreciation,
        gains: result.gains,
        replacementSummary: result.replacementSummary,
        adjustedGains: result.adjustedGains,
        tax: result.tax,
    };
    return {
        soldAssetId,
        salePrice: round2(result.salePrice),
        saleExpenses: round2(result.saleExpenses),
        inflationaryTaxableRate: Number(result.rates.inflationaryTaxableRate) || 0,
        realUntil2002Rate: Number(result.rates.realUntil2002Rate) || 0,
        real2003To2011Rate: Number(result.rates.real2003To2011Rate) || 0,
        realFrom2012Rate: Number(result.rates.realFrom2012Rate) || 0,
        advancePaid: round2(result.advancePaid),
        totalCapitalGain: round2(result.gains.totalCapitalGain),
        gainBeforeTax: round2(result.gainBeforeTax),
        totalTax: round2(result.tax.totalTax),
        balanceDue: round2(result.tax.balanceDue),
        detailsJson: JSON.stringify(details),
    };
}

/** Calculation-modal inputs saved in a snapshot. */
export function capitalGainSnapshotToInputs(snapshot) {
    if (!snapshot) return null;
    return {
        salePrice: snapshot.salePrice,
        saleExpenses: snapshot.saleExpenses,
        advancePaid: snapshot.advancePaid,
        rates: {
            inflationaryTaxableRate: snapshot.inflationaryTaxableRate,
            realUntil2002Rate: snapshot.realUntil2002Rate,
            real2003To2011Rate: snapshot.real2003To2011Rate,
            realFrom2012Rate: snapshot.realFrom2012Rate,
        },
    };
}

export function summarizeCapitalGainSnapshot(snapshot) {
    return {
        status: CAPITAL_GAIN_SUMMARY_STATUS.saved,
        totalCapitalGain: Number(snapshot.totalCapitalGain) || 0,
        gainBeforeTax: Number(snapshot.gainBeforeTax) || 0,
        totalTax: Number(snapshot.totalTax) || 0,
        balanceDue: Number(snapshot.balanceDue) || 0,
        salePrice: Number(snapshot.salePrice) || 0,
        savedAt: snapshot.updatedAt || snapshot.createdAt || null,
        updatedBy: snapshot.updatedBy || '',
        snapshot,
    };
}

export function summarizeCapitalGainResult(result) {
    return {
        status: CAPITAL_GAIN_SUMMARY_STATUS.computed,
        totalCapitalGain: Number(result.gains.totalCapitalGain) || 0,
        gainBeforeTax: Number(result.gainBeforeTax) || 0,
        totalTax: Number(result.tax.totalTax) || 0,
        balanceDue: Number(result.tax.balanceDue) || 0,
        salePrice: Number(result.salePrice) || 0,
        savedAt: null,
        result,
    };
}

export function formatSnapshotDate(value) {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
}
